import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { useTranslate, Translate } from '@bynder/localization';
import { ModalType } from '../../../types';
import { CHAPTER_NAME_MAX_LENGTH } from '../../../constants/chapters';
import { StyledButton } from '../../shared/styled-components/Sidebar';
import { IconAdd } from '@bynder/icons';
import { useModalStore } from '../../../stores/modalStore';

interface Props {
  onAddChapter: (title: string) => void;
}
export const AddChapterButton: React.FC<Props> = ({ onAddChapter }) => {
  const openModal = useModalStore.use.openModal();
  const { translate } = useTranslate();

  const onCreateChapter = (title: string) => {
    onAddChapter(title);
  };

  const handleClick = () => {
    const modalProps = {
      headerText: translate('ADD_CHAPTER_BUTTON.HEADER_TEXT'),
      labelText: translate('ADD_CHAPTER_BUTTON.LABEL_TEXT'),
      placeholderText: translate('ADD_CHAPTER_BUTTON.PLACEHOLDER_TEXT'),
      maxLength: CHAPTER_NAME_MAX_LENGTH,
    };
    openModal({
      modalType: ModalType.CREATE_MODAL,
      modalOnSubmit: onCreateChapter,
      modalProps,
    });
  };

  return (
    <StyledContainer>
      <SidebarButton data-testid="createChapterButton" onClick={handleClick}>
        <Translate id="ADD_CHAPTER_BUTTON.BUTTON_TEXT" />
      </SidebarButton>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  margin-top: ${token.spacing6};
  margin-bottom: ${token.spacing6};
`;

interface ButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
  children?: React.ReactNode;
}

const SidebarButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <StyledButton
      {...props}
      variant="clean"
      icon={<IconAdd />}
      onClick={props.onClick}
    >
      {children}
    </StyledButton>
  );
};
